/* globals $ */

import multiselectEvents from './events';

/**
 * Multiselect
 * @param {Element} element
 * @param {Object} settings
 * @return {Object}
 */
const multiselect = (element, settings) => {
  const { selector, selectOptions } = settings;
  const defaultSettings = { multiple: true, closeOnSelect: false, scrollAfterSelect: false };
  const $element = $(element);

  let $searchField;

  /**
   * Constructor
   */
  function constructor() {
    $element.select2(Object.assign({}, defaultSettings, selectOptions));
    $searchField = $element.next().find('.select2-search__field');

    bindEvents();
  }

  /**
   * Bind handlers to events
   */
  function bindEvents() {
    $element
      .on(multiselectEvents.SET_DATA, onSetData)
      .on(multiselectEvents.CLEAR, onClear)
      .on(multiselectEvents.CLEAR_ALL, onClearAll);

    $element.on('change', onChange);
  }

  /**
   * Change event handler
   */
  function onChange() {
    const options = [...element.options];
    const selectedOptions = options
      .filter(option => option.selected)
      .reduce((acc, option) => {
        acc.push({ id: option.value, name: option.getAttribute('name'), selector });
        return acc;
      }, []);

    $searchField.attr('placeholder', element.getAttribute('data-placeholder'));
    $element.trigger(multiselectEvents.CHANGE, { selectedOptions });
  }

  /**
   * Clear event handler
   * @param {Event} event
   * @param {Object} eventData
   */
  function onClear(event, { id }) {
    const options = [...element.options];

    options
      .filter(option => option.value === id)
      .forEach(option => (option.selected = false));

    onChange();
  }

  /**
   * Clear event handler
   */
  function onClearAll() {
    const options = [...element.options];
    options.forEach(option => (option.selected = false));
  }

  /**
   * Set data event handler
   * @param {Event} event
   * @param {Object} eventData
   */
  function onSetData(event, { options }) {
    if (options) {
      element.innerHTML = options.reduce(
        (acc, { id, name }) => acc + renderOption(name, id),
        '',
      );
    }
  }

  /**
   * Returns the rendered option HTML for a select
   * @param {String} name
   * @param {String} value
   * @return {String}
   */
  function renderOption(name, value) {
    return `<option name="${name}" value="${value}">${name}</option>`;
  }

  constructor();

  return {};
};

export default multiselect;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/filters/multiselect/multiselect.js